export default {
  props: {
    layout: {
      type: String,
      default: "horizontal"
    },
    title: {
      type: String,
      default: ""
    },
    tip: {
      type: String,
      default: ""
    }
  }
};